import { init, tag as edgetag, data as edgetagData } from '@blotoutio/edgetag-sdk-js';
import facebook from '@blotoutio/providers-facebook-sdk';

function ff( callback ) {
    try {
        callback();
    } catch(e) {
        // ignore errores
    }
}

function tag(...data) {
    ff( () => {
        edgetag(...data);
    });
}

function sendData( dataToSend ) {
    ff( () => {
        edgetagData(dataToSend);
    });
}

let lastUrl = undefined;
let addedToCart = false;
export function initializeEdgetag(edgeURL, pollingInterval = 500) {
    init({
        edgeURL: edgeURL,
        disableConsentCheck: true,
        providers: [facebook]
    });

    setInterval( () => {
        const currentUrl = window.location.href;
        if ( currentUrl !== lastUrl ) {
            lastUrl = currentUrl;
            tag('PageView');
        }

        if (!addedToCart) {
            edgetagAddToCart();
            addedToCart = true;
        }
    }, pollingInterval );
}

export function sendEdgetagPersonalInformation( data ) {
    sendData({
        user_id: data.user_id,
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name
    });
}

export function sendEdgetagProfile( data ) {
    sendData({
        gender: data.gender,
        date_of_birth: data.birthdate
    });
}

export function edgetagAddToCart() {
    ff( () => {
        tag('AddToCart', {
            value: 179.88,
            currency: 'USD',
        });
    });
}

export function edgetagBuy( success ) {
    ff( () => {
        const newMembership = success.data.submitNewMembershipPayment;
        const stripeSubscriptionID = newMembership.membershipId;
        const price = Number.parseFloat( newMembership.newTotal );

        const membership = newMembership.membershipOption;
        const item = {
            id: membership.id,
            quantity: 1,
            item_price: Number.parseFloat( membership.fullPrice ),
            title: membership.nameLong
        };

        const discounts = newMembership.coupon ?
            { discounts: [{ code: newMembership.coupon } ] } :
            {};

        tag('Purchase', {
            currency: 'USD',
            value: price,
            order_id: stripeSubscriptionID,
            event_id: stripeSubscriptionID,
            contents: [item],
            ...discounts
        });
    });
}